import React, { ReactNode } from "react";
import {
  QueryClientProvider,
  QueryClient,
  QueryClientConfig,
  keepPreviousData,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { IRouterProvider, INotificationProvider } from "@type";
import { RouterContextProvider } from "@contexts/router";
import { NotificationContextProvider } from "@contexts/notification";

export interface IMyDealAppProps {
  notificationProvider?: INotificationProvider | (() => INotificationProvider);
  routerProvider: IRouterProvider;
  router: ReactNode;
  reactQueryClientConfig?: QueryClientConfig;
  reactQueryDevtoolConfig?: any;
}

export const MyDealApp: React.FC<React.PropsWithChildren<IMyDealAppProps>> = ({
  notificationProvider,
  routerProvider,
  router,
  reactQueryClientConfig,
  reactQueryDevtoolConfig,
}) => {
  const queryClient = new QueryClient({
    ...reactQueryClientConfig,
    defaultOptions: {
      ...reactQueryClientConfig?.defaultOptions,
      queries: {
        refetchOnWindowFocus: false,
        placeholderData: keepPreviousData,
        ...reactQueryClientConfig?.defaultOptions?.queries,
      },
    },
  });

  const notificationProviderContextValues =
    typeof notificationProvider === "function"
      ? notificationProvider()
      : (notificationProvider ?? {});

  return (
    <QueryClientProvider client={queryClient}>
      <NotificationContextProvider {...notificationProviderContextValues}>
        <RouterContextProvider {...routerProvider}>
          {router}
        </RouterContextProvider>
      </NotificationContextProvider>
      <ReactQueryDevtools
        initialIsOpen={false}
        position="bottom-right"
        {...reactQueryDevtoolConfig}
      />
    </QueryClientProvider>
  );
};
